import React from 'react';
import RESTRICTED from '../../assets/restrictedpage.png';
import { Image } from 'react-bootstrap';


function RestrictedPage() {
    return (
        <div>
            <Image src={RESTRICTED} className='img-fluid' style={{ display: "block", margin: "auto", width: "100%", height: "100vh" }} alt='restriced' />
        </div>
    );
}

export default RestrictedPage;
